import { faWifi } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateUSConfig() {
    return (
        <div data-cy="historic-icon-updateUSConfig">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateUSConfig" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faWifi} rotation={180} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
